import React, { useState } from "react";
import MasterSearchSelect from
"../../../../../../components/common/MasterSearchSelect";

export default function LifecycleFilters({ onSearch }) {

  const [mode, setMode] = useState("material");
  const [materialId, setMaterialId] = useState("");
  const [materialLabel, setMaterialLabel] = useState("");

  const [materialType, setMaterialType] = useState("RAW_MATERIAL");
  const [batchNo, setBatchNo] = useState("");

  const handleSearch = () => {

    const filters = { mode };

    if (mode === "material") {
      filters.material_id = materialId;
      filters.material_type = materialType;
    }

    if (mode === "batch") {
      filters.batch_no = batchNo;
    }

    onSearch(filters);
  };

  return (

    <div className="lifecycle-filters">

      <div className="filter-row">

        <label>Mode</label>

        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          <option value="material">Material</option>
          <option value="batch">Batch</option>
        </select>

      </div>

      {mode === "material" && (

        <>
          <div className="filter-row">
              <label>Material</label>

              <MasterSearchSelect
                type="material"
                materialType={materialType}
                placeholder="Search Material..."
                value={materialLabel}
                onChange={(item) => {
                  setMaterialId(item?.id || "");
                  setMaterialLabel(
                    item?.material_name ||
                    item?.item_name ||
                    ""
                  );
                }}
              />
            </div>

          <div className="filter-row">
            <label>Material Type</label>

            <select
              value={materialType}
              onChange={(e) => setMaterialType(e.target.value)}
            >
              <option value="RAW_MATERIAL">Raw Material</option>
              <option value="BOUGHT_OUT">Bought Out</option>
            </select>
          </div>
        </>

      )}

      {mode === "batch" && (

        <div className="filter-row">
          <label>Batch No</label>

          <input
            value={batchNo}
            onChange={(e) => setBatchNo(e.target.value)}
          />
        </div>

      )}

      <button onClick={handleSearch}>
        Load Lifecycle
      </button>

    </div>

  );

}